export default __webpack_public_path__ + "static/media/user-dashboard.0be27ae4.png";